// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { SuggestionType } from '../../types/suggestion';
import SuggestionItem from '../SuggestionItem';
import messages from './messages';
import styles from './styles';

type Props = {
  suggestions: Array<SuggestionType>,
  suggestionsPrefix: string,
};

function SuggestionsList({ suggestions, suggestionsPrefix }: Props): React.Node {
  return (
    <div className="suggestions" data-test="sugbox">
      <h2 className="suggestions-title">
        <FormattedMessage {...messages.suggestionsTitle} />
      </h2>
      <ul className="suggestions-list">
        {suggestions.map(suggestion => (
          <SuggestionItem
            key={suggestion.id}
            suggestion={suggestion}
            suggestionsPrefix={suggestionsPrefix}
          />
        ))}
      </ul>

      <style jsx>{styles}</style>
    </div>
  );
}

export default SuggestionsList;



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionsList/index.js